import { fetch } from '@maxtropy/components';
import { PhysicalUnit } from './type';

export const getPhysicalUnits = (id?: number) =>
  fetch<{ list: PhysicalUnit[] }>(
    `/api/v2/physicalUnit/list`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  ).then(res => res.list ?? []);
